<template>
  <div class="customerManagement-view">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('miniprogram', 'bottomNavigation')" name="first">
        <tabSetting
          v-if="activeName == 'first'"
        />
      </el-tab-pane>
      <el-tab-pane :label="$t('miniprogram', 'topBackgroundColorConfig')" name="second">
        <bgSetting
          v-if="activeName == 'second'"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabSetting from "./components/tabSetting";
import bgSetting from "./components/bgSetting";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "customer-management",
  mixins: [i18nMixin],
  components: {
    tabSetting,
    bgSetting
  },
  data() {
    return {
      activeName: "first",
    };
  },
  // watch: {
  //   activeName(val, lod) {
  //     switch (val) {
  //       case "first":
  //         this.customerState = 1;
  //         break;
  //       case "second":
  //         this.customerState = 2;
  //         break;
  //       case "third":
  //         this.customerState = 3;
  //         break;
  //       default:
  //         return;
  //     }
  //   },
  // },
  
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
    
  },
};
</script>

<style lang="scss" scoped>
</style>